import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { ThemeProvider, useTheme } from "@/context/ThemeContext";
import ThemeSwitcher from "@/components/ThemeSwitcher";
import VoiceAssistant from "@/components/VoiceAssistant";
import Landing from "@/pages/Landing";
import Auth from "@/pages/Auth";
import Awaken from "@/pages/Awaken";
import System from "@/pages/System";
import Training from "@/pages/Training";
import Coach from "@/pages/Coach";
import NeuralHub from "@/pages/NeuralHub";
import Library from "@/pages/Library";
import Nutrition from "@/pages/Nutrition";
import Channel from "@/pages/Channel";

function ThemedRoutes() {
  const { theme } = useTheme();
  return (
    <div
      className="theme-scope"
      style={{ filter: `hue-rotate(${theme.hue}deg) saturate(${theme.sat})` }}
    >
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/auth" element={<Auth />} />
          <Route path="/awaken" element={<Awaken />} />
          <Route path="/system" element={<System />} />
          <Route path="/training" element={<Training />} />
          <Route path="/coach" element={<Coach />} />
          <Route path="/hub" element={<NeuralHub />} />
          <Route path="/library" element={<Library />} />
          <Route path="/nutrition" element={<Nutrition />} />
          <Route path="/channel" element={<Channel mode="general" />} />
        </Routes>
        <VoiceAssistant />
      </BrowserRouter>
    </div>
  );
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <ThemeProvider>
          <ThemedRoutes />
          <ThemeSwitcher />
        </ThemeProvider>
      </AuthProvider>
    </div>
  );
}

export default App;
